import { Component } from "@angular/core";
import { environment } from "environment";
import { IdleTimeoutEvent, IdleTimerService } from "./common/services/idle-timer.service";
import { RouteTrackingService } from "./common/services/route-tracking.service";
import { StorageService } from "./common/services/storage.service";
import { AuthService } from "./services/auth.service";
import { IdleTimerConstants } from "./common/constants/idle-timer.constants";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  isPhysican: boolean;
  constructor(
    public storageService: StorageService,
    private routeTrackingService: RouteTrackingService,
    private idleTimerService: IdleTimerService,
    private authService: AuthService
  ) {
    this.isPhysican = false;
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }

  ngOnInit(): void {
    this.routeTrackingService.init();
    this.storageService.isUserPhysician.subscribe((val) => {
      this.isPhysican = val;
    });
    this.setIdleTimer();
  }

  setIdleTimer() {
      if (!!environment.idleTimeBeforeLocking && !!environment.idleTimeBeforeTerminating) {
        const timers: IdleTimeoutEvent[] = [
          { time: environment.idleTimeBeforeLocking, message: IdleTimerConstants.lockUser },
          { time: environment.idleTimeBeforeTerminating, message: IdleTimerConstants.terminateUser },
        ];
        this.idleTimerService.setTimers(timers).subscribe((timerData) => {
            this.idleTimerService.stop();
            if (timerData.message === IdleTimerConstants.lockUser) {
              this.authService.lockUserSession();
            } else if (timerData.message === IdleTimerConstants.terminateUser) {
              this.authService.logout();
            }
          });
      }
    }

    ngOnDestroy() {
      this.idleTimerService.stop();
    }

}
